module.exports = {
  path: 'recover_password',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/recoverPassword/index.js